import React, {useEffect, useState} from 'react';
import axios from "axios";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Header from './Header'
import AuthPage from './AuthPage';
import Diary from './Diary';
import Wishlist from './Wishlist';
import Collection from './Collection';
import Lists from './Lists';
import Users from './Users'
import Albums from './Albums';
import List from './List';
import Settings from './Settings';
import Profile from './Profile';
import OtherProfile from './OtherProfile';
import OtherUserDiary from './OtherUserDiary';
import OtherUserWishlist from './OtherUserWishlist';
import OtherUserLists from './OtherUserLists';
import OtherUserList from './OtherUserList';
import OtherUserFollowers from './OtherUserFollowers';
import OtherUserFollowing from './OtherUserFollowing';
import NotFound from './NotFound';

axios.interceptors.request.use((req) => {
    console.log("API Request:", req);
    return req;
});

function App() {
    const [role, setRole] = useState(null);
    const [authenticated, setAuthenticated] = useState(false);

    const checkLogin = () => {
        fetch('/api/auth/check-login')
            .then(res => res.ok && res.json())
            .then(data => {
                if (data?.loggedIn) {
                    setAuthenticated(true);
                    setRole(data.role);
                }
            })
    }

    useEffect(() => {
        checkLogin();
    }, []);

    if (!authenticated) {
        return <AuthPage onLogin={(role) => {
            const redirectPath = role === 'user' ? '/diary' : '/users';
            window.history.replaceState({}, '', redirectPath);
            setAuthenticated(true);
            setRole(role);
        }} />;
    }

    const handleLogout = () => { fetch('/api/auth/logout').then(() => setAuthenticated(false)); };
    if (role === 'user') {
        return (
            <Router>
                <Header links={userLinks} onLogout={handleLogout} />
                <Routes>
                    {userRoutes.map(({path, element}) => ( <Route key={path} path={path} element={element}/> ))}
                </Routes>
            </Router>
        );
    }
    else if (role === 'admin') {
        return (
            <Router>
                <Header links={adminLinks} onLogout={handleLogout} />
                <Routes>
                    {adminRoutes.map(({path, element}) => ( <Route key={path} path={path} element={element}/> ))}
                </Routes>
            </Router>
        );
    }
    return <div className="text-white p-4"> Loading...</div>;
}

const userLinks = [
    { path: "/diary", label: "Diary" },
    { path: "/wishlist", label: "Wishlist" },
    { path: "/collection", label: "Collection" },
    { path: "/lists", label: "Lists" },
    { path: "/profile", label: "Profile", end: true },
    { path: "/settings", label: "Settings" }
];

const userRoutes = [
    { path: "/", element: <Diary /> },
    { path: "/diary", element: <Diary /> },
    { path: "/wishlist", element: <Wishlist /> },
    { path: "/collection", element: <Collection /> },
    { path: "/lists", element: <Lists /> },
    { path: "/lists/:listId", element: <List /> },
    { path: "/profile", element: <Profile /> },
    { path: "/profile/:userId", element: <OtherProfile /> },
    { path: "/profile/:userId/diary", element: <OtherUserDiary /> },
    { path: "/profile/:userId/wishlist", element: <OtherUserWishlist /> },
    { path: "/profile/:userId/lists", element: <OtherUserLists /> },
    { path: "/profile/:userId/lists/:listId", element: <OtherUserList /> },
    { path: "/profile/:userId/followers", element: <OtherUserFollowers /> },
    { path: "/profile/:userId/following", element: <OtherUserFollowing /> },
    { path: "/settings", element: <Settings /> },
    { path: "*", element: <NotFound /> }
];

const adminLinks = [
    { path: "/users", label: "Users" },
    { path: "/albums", label: "Albums" },
    { path: "/profile", label: "Profile", end: true },
];

const adminRoutes = [
    { path: "/", element: <Users /> },
    { path: "/users", element: <Users /> },
    { path: "/albums", element: <Albums /> },
    { path: "/profile", element: <Profile /> },
    { path: "*", element: <NotFound /> },
];

export default App;